import { RestClient } from '@/api/rest-client'
import { Branding } from '@/api/model/branding'

export class BrandingClient extends RestClient<Branding> {
    collectionName = 'brandings'
    parseData = Branding.fromData

    async update(id: string, data: any): Promise<Branding> {
        const formData = new FormData()
        Object.keys(data).forEach(key => {
            formData.append(key, data[key])
        })

        try {
            const response = await this.client.post(`${this.basePath}/${this.collectionName}/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            return this.get(id)
        } catch (error) {
            this.handleError(error)
        }
    }
}
